import {
  IEmailPreference,
  LONotificationSettings,
  TEmailPreferenceKey
} from "../../types"

export const mapSettingsToPreferences = (
  preferences: IEmailPreference[],
  isDefault: boolean,
  notification_settings: LONotificationSettings = {}
): Record<TEmailPreferenceKey, boolean> =>
  preferences.reduce(
    (acc, pref) => ({
      ...acc,
      [pref.key]: isDefault ? true : notification_settings[pref.key] ?? true
    }),
    {} as Record<TEmailPreferenceKey, boolean>
  )
